import { fetchApi } from '../api/collectionManager';
import { getFileMetadata } from '../api/digitalVault';
import { parseCollection, parseFiles } from '../utils/parser';
import { fetchCache, getCacheKey, persistCache, parseCollectionsPagination, validateCache, } from '../utils';
const getSharedCollectionById = async (params = {}, collectionId, collectionCacheProps, logger) => {
    if (collectionCacheProps?.enableCache) {
        const key = getCacheKey({
            params,
            endpoint: `${collectionCacheProps.cacheKeyPrefix}-shared/collections/${collectionId}`,
        });
        const cacheResp = await fetchCache('user_collections', key);
        if (cacheResp) {
            const { hasNextPage, nextPageParams } = parseCollectionsPagination(cacheResp.data.links);
            return {
                data: cacheResp.parsedFiles,
                isDataFromCache: true,
                updateCache: false,
                hasNextPage,
                collectionName: cacheResp.data.name,
                mediaItemsCount: cacheResp.data.mediaItemsCount,
                collectionId: cacheResp.data.id,
                creationDate: cacheResp.data.creationDate,
                source: cacheResp.data.source,
                type: cacheResp.data.type,
                clientAttributes: cacheResp.data.clientAttributes,
                coverItem: cacheResp.data.coverItem,
                paginate() {
                    return (hasNextPage &&
                        getSharedCollectionById(nextPageParams, collectionId, collectionCacheProps, logger));
                },
            };
        }
    }
    return await sharedCollectionByIdApi(params, collectionId, collectionCacheProps, logger);
};
const sharedCollectionByIdApi = async (params, collectionId, collectionCacheProps, logger) => {
    let collection = await fetchApi(params, `/shared/collections/${collectionId}`, logger);
    let updateCache = false;
    if (collection?.collectionItems) {
        const { hasNextPage, nextPageParams } = parseCollectionsPagination(collection.links);
        const collectionMetaData = await getFileMetadata(parseCollection(collection, true), logger, true);
        const data = parseFiles(collectionMetaData.files);
        const parsedFiles = data.map((file) => {
            Array.isArray(collection.collectionItems)
                ? collection.collectionItems
                : [collection.collectionItems];
            return { collectionId: collection.id, ...file };
        });
        const key = getCacheKey({
            params,
            endpoint: `${collectionCacheProps?.cacheKeyPrefix}-shared/collections/${collectionId}`,
        });
        const value = { url: key, data: collection, parsedFiles };
        if (collectionCacheProps?.validateCache) {
            const { dataUpdated } = await validateCache('user_collections', key, value);
            updateCache = dataUpdated;
        }
        if (collectionCacheProps?.enableCache || updateCache) {
            await persistCache('user_collections', key, value);
        }
        return {
            data: parsedFiles,
            isDataFromCache: false,
            updateCache,
            hasNextPage,
            collectionName: collection.name,
            mediaItemsCount: collection.mediaItemsCount,
            collectionId: collection.id,
            creationDate: collection.creationDate,
            source: collection.source,
            type: collection.type,
            clientAttributes: collection.clientAttributes,
            coverItem: collection.coverItem,
            paginate() {
                return (hasNextPage &&
                    getSharedCollectionById(nextPageParams, collectionId, collectionCacheProps, logger));
            },
        };
    }
    return {
        hasNextPage: false,
        data: [],
        isDataFromCache: false,
        updateCache: false,
        paginate() {
            return null;
        },
    };
};
export default getSharedCollectionById;
